(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["certificate-verification-v6"] && !Shopify.designMode) return;
  try {
    
(() => {
  const details = [['Shape','shape'],['Bodycolor','bodycolor'],['Overtone','overtone'],['Size','size'],['Nacre','nacre'],['Surface','surface'],['Identification','identification'],['Environment','environment'],['Origin','origin']];
  const quality = [['Luster Scale','luster'],['Sphericity','sphericity'],['Surface Quality','surfaceQuality']];
  const value = raw => raw == null || String(raw).trim() === '' ? 'Not provided' : String(raw);
  function boot(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const find = selector => root.querySelector(selector);
    const form = find('form'), input = find('input'), result = find('[data-result]');
    const gallery = find('[data-media-gallery]'), mediaStage = find('[data-media-stage]'), mediaThumbs = find('[data-media-thumbs]');
    let sequence = 0, controller;
    function state(name, message) {
      root.dataset.state = name;
      result.hidden = name !== 'success';
      find('[data-skeleton]').hidden = name !== 'loading';
      root.setAttribute('aria-busy', String(name === 'loading'));
      find('[role="status"]').textContent = message;
    }
    function rows(selector, fields, certificate) {
      find(selector).replaceChildren(...fields.map(([label, key]) => {
        const row = document.createElement('div'), dt = document.createElement('dt'), dd = document.createElement('dd');
        dt.textContent = label; dd.textContent = value(certificate[key]); row.append(dt, dd); return row;
      }));
    }
    function normalizedMedia(certificate) {
      const source = Array.isArray(certificate.mediaItems)
        ? certificate.mediaItems
        : (Array.isArray(certificate.media) ? certificate.media : []);
      const candidates = source.length ? source : (certificate.productImageUrl ? [{type:'image',url:certificate.productImageUrl,role:'primary'}] : []);
      const seen = new Set();
      return candidates.map((item, index) => {
        const rawUrl = typeof item === 'string' ? item : (item.url || item.src || item.imageUrl || '');
        let url;
        try { const parsed = new URL(rawUrl); if (parsed.protocol === 'https:') url = parsed.href; } catch (_) { return null; }
        if (!url || seen.has(url)) return null;
        seen.add(url);
        const rawType = typeof item === 'string' ? '' : String(item.type || item.mediaType || '');
        const type = rawType.toLowerCase() === 'video' || /\.(mp4|webm)(\?|$)/i.test(url) ? 'video' : 'image';
        const thumbnailUrl = typeof item === 'string' ? '' : String(item.thumbnailUrl || item.posterUrl || '');
        return {id: String((typeof item === 'string' ? '' : item.id) || index + 1),type,url,thumbnailUrl,alt:String((typeof item === 'string' ? '' : item.alt) || 'Certificate media ' + (index + 1))};
      }).filter(Boolean);
    }
    function renderMedia(certificate, request) {
      let items = normalizedMedia(certificate);
      let thumbButtons = [];
      gallery.hidden = true; mediaStage.replaceChildren(); mediaThumbs.replaceChildren(); result.setAttribute('data-no-media','');
      function reveal() { if (request !== sequence) return; gallery.hidden = false; result.removeAttribute('data-no-media'); }
      function removeFailed(index) {
        if (request !== sequence) return;
        items.splice(index, 1);
        if (!items.length) { gallery.hidden = true; mediaStage.replaceChildren(); mediaThumbs.replaceChildren(); result.setAttribute('data-no-media',''); return; }
        drawThumbs(); show(Math.min(index, items.length - 1));
      }
      function drawThumbs() {
        if (items.length < 2) { thumbButtons = []; mediaThumbs.replaceChildren(); mediaThumbs.hidden = true; return; }
        thumbButtons = items.map((item, index) => {
          const button = document.createElement('button');
          button.type = 'button'; button.className = 'db-certificate__media-thumb'; button.setAttribute('aria-label','Show certificate media ' + (index + 1));
          if (item.thumbnailUrl && item.type === 'video') {
            const thumb = document.createElement('img'); thumb.src = item.thumbnailUrl; thumb.alt = ''; button.append(thumb);
          } else if (item.type === 'image') {
            const thumb = document.createElement('img'); thumb.src = item.url; thumb.alt = ''; button.append(thumb);
          } else {
            const label = document.createElement('span'); label.textContent = 'Video'; button.append(label);
          }
          button.addEventListener('click', () => show(index));
          return button;
        });
        mediaThumbs.replaceChildren(...thumbButtons); mediaThumbs.hidden = false;
      }
      function show(index) {
        const item = items[index]; if (!item) return;
        thumbButtons.forEach((button, buttonIndex) => button.setAttribute('aria-current',String(buttonIndex === index)));
        mediaStage.replaceChildren();
        if (item.type === 'video') {
          const video = document.createElement('video'); video.controls = true; video.preload = 'metadata'; video.playsInline = true;
          if (item.thumbnailUrl) video.poster = item.thumbnailUrl;
          video.addEventListener('loadedmetadata', reveal); video.addEventListener('error', () => removeFailed(index));
          video.src = item.url; mediaStage.append(video);
        } else {
          const image = new Image(); image.alt = item.alt; image.decoding = 'async';
          image.onload = reveal; image.onerror = () => removeFailed(index); image.src = item.url; mediaStage.append(image);
        }
      }
      if (items.length) { drawThumbs(); show(0); }
    }
    function render(certificate, request) {
      root.querySelectorAll('[data-value]').forEach(el => { el.textContent = value(certificate[el.dataset.value]); });
      const date = find('[data-date]'), raw = certificate.issueDate;
      const parsed = /^\d{4}-\d{2}-\d{2}$/.test(raw || '') ? new Date(raw + 'T00:00:00Z') : null;
      date.textContent = parsed && !Number.isNaN(parsed.getTime()) ? new Intl.DateTimeFormat('en-US',{month:'long',day:'numeric',year:'numeric',timeZone:'UTC'}).format(parsed) : value(raw);
      date.removeAttribute('datetime');
      if (parsed && !Number.isNaN(parsed.getTime())) date.setAttribute('datetime', raw);
      rows('[data-details]', details, certificate); rows('[data-quality]', quality, certificate);
      const description = String(certificate.itemDescription || '').trim();
      find('[data-description]').textContent = description; find('[data-description-wrap]').hidden = !description;
      renderMedia(certificate, request);
      state('success', 'Certificate ' + certificate.certificateNo + ' verified.');
    }
    async function query(raw, updateUrl) {
      const request = ++sequence;
      if (controller) controller.abort();
      const no = String(raw || '').trim();
      input.value = no;
      input.setAttribute('aria-invalid', String(!/^\d{9}$/.test(no)));
      if (!/^\d{9}$/.test(no)) { state('error', 'Enter a valid 9-digit certificate number.'); return; }
      if (updateUrl) { const url = new URL(window.location.href); url.searchParams.set('no',no); window.history.replaceState(window.history.state,'',url); }
      controller = new AbortController();
      const activeController = controller;
      const timer = setTimeout(() => activeController.abort(), 15000);
      state('loading', root.dataset.loadingText || 'Verifying certificate…');
      try {
        const origin = (root.dataset.apiOrigin || 'https://certificates.deblancas.com').replace(/\/+$/,'');
        const response = await fetch(origin + '/api/certificates/' + encodeURIComponent(no), {headers:{Accept:'application/json'},signal:activeController.signal});
        if (request !== sequence) return;
        if (response.status === 404) { state('error','No published certificate was found for No. ' + no + '. Check the number and try again.'); return; }
        if (!response.ok) throw new Error('Verification unavailable');
        const payload = await response.json();
        if (request !== sequence) return;
        if (!payload.certificate || String(payload.certificate.certificateNo) !== no) throw new Error('Invalid certificate response');
        render(payload.certificate, request);
      } catch (_) {
        if (request === sequence) state('error','Unable to verify right now. Check your connection and try again.');
      } finally { clearTimeout(timer); }
    }
    form.addEventListener('submit', event => { event.preventDefault(); query(input.value, true); });
    const initial = new URLSearchParams(window.location.search).get('no');
    if (initial !== null) query(initial, false);
  }
  function bootAll() { document.querySelectorAll('[data-db-certificate]').forEach(boot); }
  bootAll();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootAll, {once:true});
  document.addEventListener('shopify:section:load', bootAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["giveaway-prizes"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
    const pad = (value) => String(value).padStart(2, '0');
    let mediaTicking = false;
    let revealObserver = null;

    const revealGiveawaySection = (section) => {
      section.classList.add('is-scroll-visible');
      section.dataset.giveawayRevealReady = 'true';
    };

    const initGiveawayReveal = (section) => {
      if (!section || section.dataset.giveawayRevealReady === 'true') {
        return;
      }

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
        revealGiveawaySection(section);
        return;
      }

      if (!revealObserver) {
        revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) {
                return;
              }

              revealGiveawaySection(entry.target);
              revealObserver.unobserve(entry.target);
            });
          },
          {
            rootMargin: '0px 0px -12% 0px',
            threshold: 0.16
          }
        );
      }

      revealObserver.observe(section);
    };

    const setActiveMediaFrame = (frames, activeIndex) => {
      frames.forEach((frame, index) => {
        frame.classList.toggle('is-active', index === activeIndex);
      });
    };

    const updateGiveawayMedia = () => {
      mediaTicking = false;

      document.querySelectorAll('.db-giveaway-hero[data-section-id]').forEach((section) => {
        const frames = Array.from(section.querySelectorAll('[data-giveaway-frame]'));

        if (frames.length <= 1) {
          if (frames[0]) {
            setActiveMediaFrame(frames, 0);
          }

          return;
        }

        const rect = section.getBoundingClientRect();
        const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 1;
        const progress = clamp((viewportHeight - rect.top) / (viewportHeight + rect.height), 0, 1);
        const activeIndex = Math.min(frames.length - 1, Math.floor(progress * frames.length * 1.28));

        setActiveMediaFrame(frames, activeIndex);
      });
    };

    const requestGiveawayMediaUpdate = () => {
      if (mediaTicking) {
        return;
      }

      mediaTicking = true;
      window.requestAnimationFrame(updateGiveawayMedia);
    };

    const parseDeadline = (rawDeadline) => {
      const raw = (rawDeadline || '').trim();

      if (!raw) {
        return null;
      }

      const normalized = raw.includes('T') ? raw : raw.replace(' ', 'T');
      const parsed = new Date(normalized);

      if (Number.isNaN(parsed.getTime())) {
        return null;
      }

      return parsed;
    };

    const setTimerText = (section, values) => {
      const days = section.querySelector('[data-giveaway-days]');
      const hours = section.querySelector('[data-giveaway-hours]');
      const minutes = section.querySelector('[data-giveaway-minutes]');
      const seconds = section.querySelector('[data-giveaway-seconds]');

      if (days) days.textContent = pad(values.days);
      if (hours) hours.textContent = pad(values.hours);
      if (minutes) minutes.textContent = pad(values.minutes);
      if (seconds) seconds.textContent = pad(values.seconds);
    };

    const initGiveawayTimer = (section) => {
      const timer = section.querySelector('[data-giveaway-timer]');

      if (!timer || section.dataset.giveawayTimerReady === 'true') {
        return;
      }

      const deadline = parseDeadline(section.dataset.giveawayDeadline);

      if (!deadline) {
        setTimerText(section, { days: 0, hours: 0, minutes: 0, seconds: 0 });
        section.classList.add('is-deadline-missing');
        return;
      }

      section.dataset.giveawayTimerReady = 'true';

      const tick = () => {
        const remaining = Math.max(0, Math.floor((deadline.getTime() - Date.now()) / 1000));
        const days = Math.floor(remaining / 86400);
        const hours = Math.floor((remaining % 86400) / 3600);
        const minutes = Math.floor((remaining % 3600) / 60);
        const seconds = remaining % 60;

        setTimerText(section, { days, hours, minutes, seconds });

        if (remaining <= 0) {
          section.classList.add('is-expired');
          window.clearInterval(interval);
        }
      };

      const interval = window.setInterval(tick, 1000);
      tick();
    };

    const initAllGiveawayTimers = () => {
      document.querySelectorAll('.db-giveaway-hero[data-giveaway-deadline]').forEach(initGiveawayTimer);
    };

    const initAllGiveawayReveals = () => {
      document.querySelectorAll('.db-giveaway-hero--scroll-fade').forEach(initGiveawayReveal);
    };

    const initAllGiveawayMedia = () => {
      requestGiveawayMediaUpdate();
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => {
          initAllGiveawayReveals();
          initAllGiveawayTimers();
          initAllGiveawayMedia();
        },
        { once: true }
      );
    } else {
      initAllGiveawayReveals();
      initAllGiveawayTimers();
      initAllGiveawayMedia();
    }

    window.addEventListener('scroll', requestGiveawayMediaUpdate, { passive: true });
    window.addEventListener('resize', requestGiveawayMediaUpdate);

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.db-giveaway-hero[data-giveaway-deadline]');

      if (section) {
        initGiveawayReveal(section);
        initGiveawayTimer(section);
        requestGiveawayMediaUpdate();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["june-pearl-design-challenge"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sections = document.querySelectorAll("[data-db-modern-challenge]");

    sections.forEach((section) => {
      const deadline = new Date(section.dataset.deadline || "2026-06-25T23:59:00-07:00").getTime();
      const days = section.querySelector("[data-days]");
      const hours = section.querySelector("[data-hours]");
      const minutes = section.querySelector("[data-minutes]");
      const seconds = section.querySelector("[data-seconds]");
      const copyButton = section.querySelector("[data-copy-caption]");
      const caption = section.querySelector("[data-caption-text]");

      const render = () => {
        const remaining = Math.max(0, deadline - Date.now());
        const values = [
          Math.floor(remaining / 86400000),
          Math.floor((remaining % 86400000) / 3600000),
          Math.floor((remaining % 3600000) / 60000),
          Math.floor((remaining % 60000) / 1000),
        ];

        if (days) days.textContent = String(values[0]).padStart(2, "0");
        if (hours) hours.textContent = String(values[1]).padStart(2, "0");
        if (minutes) minutes.textContent = String(values[2]).padStart(2, "0");
        if (seconds) seconds.textContent = String(values[3]).padStart(2, "0");
      };

      render();
      window.setInterval(render, 1000);

      if (copyButton && caption) {
        copyButton.addEventListener("click", async () => {
          const original = copyButton.textContent;
          try {
            await navigator.clipboard.writeText(caption.textContent.trim());
            copyButton.textContent = "Copied";
          } catch (error) {
            copyButton.textContent = "Select Caption";
          }
          window.setTimeout(() => {
            copyButton.textContent = original;
          }, 1800);
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  if (!customElements.get('collection-editorial-video')) {
    class CollectionEditorialVideo extends HTMLElement {
      connectedCallback() {
        this.videos = [...this.querySelectorAll('[data-collection-editorial-video-media]')];
        this.control = this.querySelector('[data-collection-editorial-video-control]');
        this.fallback = this.querySelector('.collection-editorial-video__image');
        this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.target.offsetParent === null) return;
            if (entry.isIntersecting) {
              if (!this.reduceMotion.matches && !this.saveData) this.prepareAndPlay(entry.target);
            } else {
              entry.target.pause();
            }
          });
        }, { rootMargin: '120px 0px', threshold: 0.2 });

        this.videos.forEach((video) => {
          this.observer.observe(video);
          video.addEventListener('loadeddata', () => this.revealVideo(video));
          video.addEventListener('error', () => this.classList.remove('is-video-active'));
          video.addEventListener('play', () => this.updateControl(false));
          video.addEventListener('pause', () => this.updateControl(true));
        });

        if (this.control) {
          this.control.addEventListener('click', () => this.togglePlayback());
          if (this.reduceMotion.matches || this.saveData) this.updateControl(true);
        }
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      visibleVideo() {
        return this.videos.find((video) => video.offsetParent !== null);
      }

      loadVideo(video) {
        if (video.dataset.loaded === 'true') return;
        video.querySelectorAll('source[data-src]').forEach((source) => {
          source.src = source.dataset.src;
        });
        if (video.dataset.poster) video.poster = video.dataset.poster;
        video.load();
        video.dataset.loaded = 'true';
      }

      async prepareAndPlay(video) {
        if (this.fallback && !this.fallback.complete) {
          try {
            await this.fallback.decode();
          } catch (error) {
            // Continue with the video if the browser cannot decode the fallback.
          }
        }
        this.loadVideo(video);
        this.playVideo(video);
      }

      revealVideo(video) {
        if (video !== this.visibleVideo()) return;
        this.classList.add('is-video-active');
      }

      playVideo(video) {
        const playback = video.play();
        if (playback) playback.catch(() => this.updateControl(true));
      }

      togglePlayback() {
        const video = this.visibleVideo();
        if (!video) return;
        this.loadVideo(video);
        if (video.paused) {
          this.playVideo(video);
        } else {
          video.pause();
        }
      }

      updateControl(paused) {
        if (!this.control) return;
        this.control.classList.toggle('is-paused', paused);
        this.control.setAttribute('aria-label', paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      }
    }

    customElements.define('collection-editorial-video', CollectionEditorialVideo);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["necklace-builder-cta"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('necklace-builder-cta')) {
    customElements.define('necklace-builder-cta', class NecklaceBuilderCta extends HTMLElement {
      constructor() {
        super();
        this.frame = null;
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.boundRequestTick = this.requestTick.bind(this);
        this.boundResize = this.handleResize.bind(this);
        this.boundMotionChange = this.requestTick.bind(this);
      }

      connectedCallback() {
        this.pearls = Array.from(this.querySelectorAll('[data-pearl]'));
        this.labels = Array.from(this.querySelectorAll('[data-pearl-label]'));
        this.textureSources = Array.from(this.querySelectorAll('[data-pearl-texture]'));
        this.visual = this.querySelector('.necklace-builder-cta__visual');
        this.clasp = this.querySelector('.necklace-builder-cta__clasp');
        this.isSpline = this.dataset.animationMode === 'spline';
        this.intensity = Math.max(0, Math.min(100, Number(this.dataset.intensity) || 75)) / 100;
        this.timing = {
          factFadeStart: this.getTimingPercent('factFadeStart', 4),
          factFadeDuration: this.getTimingDuration('factFadeDuration', 18),
          pearlRevealStart: this.getTimingPercent('pearlRevealStart', 26),
          pearlRevealDuration: this.getTimingDuration('pearlRevealDuration', 16),
          introRevealSequenceSpread: this.getTimingDuration('introRevealSequenceSpread', 18),
          motionStart: this.getTimingPercent('motionStart', 58),
          motionEnd: this.getTimingPercent('motionEnd', 96),
          copyRevealDelay: this.getTimingDuration('copyRevealDelay', 4),
          copyRevealDuration: this.getTimingDuration('copyRevealDuration', 28),
          labelFadeDuration: this.getTimingDuration('labelFadeDuration', 18)
        };
        this.applyTextures();
        this.bindEvents();
        this.requestTick();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.boundRequestTick);
        window.removeEventListener('resize', this.boundResize);
        if (this.motionQuery && typeof this.motionQuery.removeEventListener === 'function') {
          this.motionQuery.removeEventListener('change', this.boundMotionChange);
        }
        if (this.frame) {
          window.cancelAnimationFrame(this.frame);
          this.frame = null;
        }
      }

      bindEvents() {
        window.addEventListener('scroll', this.boundRequestTick, { passive: true });
        window.addEventListener('resize', this.boundResize, { passive: true });
        if (this.motionQuery && typeof this.motionQuery.addEventListener === 'function') {
          this.motionQuery.addEventListener('change', this.boundMotionChange);
        }
      }

      handleResize() {
        this.requestTick();
      }

      applyTextures() {
        if (!this.pearls || !this.pearls.length) return;

        var textureItems = (this.textureSources || [])
          .map((source) => {
            return {
              url: source.getAttribute('data-pearl-texture'),
              label: (source.getAttribute('data-pearl-texture-label') || '').trim()
            };
          })
          .filter((item) => item.url);
        var textures = textureItems.map((item) => item.url);
        var labelItems = textureItems.filter((item) => {
          return item.label && item.label.toLowerCase() !== 'pearl texture';
        });

        this.pearls.forEach((pearl, index) => {
          if (!textures.length) {
            pearl.classList.remove('has-texture');
            pearl.style.removeProperty('--texture-url');
            pearl.style.removeProperty('--texture-position');
            pearl.style.removeProperty('--texture-size');
            pearl.style.removeProperty('--texture-rotation');
            return;
          }

          var textureUrl = textures[index % textures.length];
          var offsetX = 48 + ((index * 17) % 15) - 7;
          var offsetY = 50 + ((index * 23) % 13) - 6;
          var textureSize = 104 + ((index * 7) % 11);
          var rotation = ((index * 37) % 34) - 17;

          pearl.classList.add('has-texture');
          pearl.style.setProperty('--texture-url', 'url("' + textureUrl + '")');
          pearl.style.setProperty('--texture-position', offsetX + '% ' + offsetY + '%');
          pearl.style.setProperty('--texture-size', textureSize + '% ' + textureSize + '%');
          pearl.style.setProperty('--texture-rotation', rotation + 'deg');
        });

        (this.labels || []).forEach((label, index) => {
          var item = labelItems.length ? labelItems[index % labelItems.length] : null;
          if (!item) {
            label.textContent = '';
            label.hidden = true;
            label.style.setProperty('--label-opacity', '0');
            return;
          }

          label.textContent = item.label;
          label.hidden = false;
        });
      }

      requestTick() {
        if (this.frame) return;
        this.frame = window.requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }

      update() {
        if (!this.visual) return;

        var compactProduct = document.body.classList.contains('template-product') && window.matchMedia('(max-width: 767px)').matches;
        if (compactProduct) return;
        var progress = this.motionQuery.matches ? 1 : this.getProgress();
        var eased = this.easeInOutCubic(progress);
        var width = this.visual.offsetWidth || window.innerWidth || 600;
        var height = this.visual.offsetHeight || 450;
        var mobile = window.matchMedia('(max-width: 899px)').matches;
        var visiblePearls = mobile ? this.pearls.slice(0, Math.min(this.pearls.length, 32)) : this.pearls;
        var count = visiblePearls.length;
        var introCount = Math.min(8, count);
        var pulseStrength = this.getTimingPercent('motionPulseStrength', 8);
        var pulseDuration = this.getTimingDuration('motionPulseDuration', 24);
        var introSequenceSpread = this.getTimingDuration('introSequenceSpread', 18);
        var introRevealStartScale = this.getTimingPercent('introRevealStartScale', 76);
        var mobileNecklaceWidth = this.getTimingPercent('mobileNecklaceWidth', 78);
        var mobileNecklaceY = this.getTimingPercent('mobileNecklaceY', 30);
        var mobileMotionStart = this.getTimingPercent('mobileMotionStart', 54);
        var mobileMotionEnd = this.getTimingPercent('mobileMotionEnd', 96);
        var mobileScatterTop = this.getTimingPercent('mobileScatterTop', 32);
        var mobileScatterHeight = this.getTimingPercent('mobileScatterHeight', 36);
        var mobileFinalPearlSize = this.getNumberSetting('mobileFinalPearlSize', 17, 12, 24);
        var mobileIntroPearlSize = this.getNumberSetting('mobileIntroPearlSize', 46, 30, 64);
        var introPulseLead = Math.min(0.045, pulseDuration * 0.32);
        var necklaceBoxWidth = Math.min(width * (mobile ? mobileNecklaceWidth : 0.36), mobile ? width * 0.92 : 440);
        var sidePadding = mobile ? width * 0.08 : Math.max(34, width * 0.045);
        var configuredNecklaceOffsetX = Number(this.dataset.necklaceOffsetX);
        if (!Number.isFinite(configuredNecklaceOffsetX)) configuredNecklaceOffsetX = -35;
        var necklaceOffsetX = mobile ? 0 : configuredNecklaceOffsetX;
        var centerX = (mobile ? width * 0.5 : width - necklaceBoxWidth * 0.52 - sidePadding) + necklaceOffsetX;
        var centerY = height * (mobile ? mobileNecklaceY : 0.52);
        var radiusX = necklaceBoxWidth * (mobile ? 0.38 : 0.315);
        var radiusY = height * (mobile ? 0.165 : 0.355);
        var claspGapAngle = mobile ? 0.31 : 0.28;
        var necklaceSpan = Math.PI * 2 - claspGapAngle * 2;
        var floatPhase = Date.now() / 1600;
        var timing = this.timing || {};
        var introMotionStart = mobile ? mobileMotionStart : timing.motionStart;
        var motionEnd = mobile
          ? Math.max(introMotionStart + 0.05, mobileMotionEnd)
          : Math.max(introMotionStart + 0.05, timing.motionEnd);
        var formation = this.easeInOutCubic(this.clamp((progress - introMotionStart) / (motionEnd - introMotionStart)));
        var copyReveal = this.easeOutCubic(this.clamp((progress - (introMotionStart + timing.copyRevealDelay)) / timing.copyRevealDuration));
        var copyFocus = this.clamp((formation - 0.18) / 0.82);
        var copyOpacity = copyReveal * (0.22 + copyFocus * 0.78);
        var factFade = this.easeOutCubic(this.clamp((progress - timing.factFadeStart) / timing.factFadeDuration));
        var configuredIntroRowY = Number(this.dataset.introRowY);
        if (!Number.isFinite(configuredIntroRowY)) configuredIntroRowY = 155;
        var introRowY = mobile
          ? Math.max(116, Math.min(configuredIntroRowY * 0.86, height * 0.3))
          : Math.max(180, Math.min(configuredIntroRowY + 36, 246));
        var mobileIntroScatterX = [0.16, 0.42, 0.68, 0.84, 0.28, 0.58, 0.76, 0.36];
        var mobileIntroScatterY = [0.12, 0, 0.14, 0.38, 0.58, 0.66, 0.89, 1];
        var mobileIntroScatterDepth = [0.9, 1, 0.94, 0.84, 0.92, 0.86, 0.8, 0.88];
        var mobileIntroRevealOrder = mobileIntroScatterY
          .map(function(value, index) { return { value: value, index: index }; })
          .sort(function(a, b) { return a.value - b.value; })
          .reduce(function(order, item, position) {
            order[item.index] = position;
            return order;
          }, []);

        this.style.setProperty('--nb-copy-opacity', copyOpacity.toFixed(3));
        this.style.setProperty('--nb-copy-y', (28 - copyReveal * 28).toFixed(2) + 'px');
        this.style.setProperty('--nb-fact-opacity', (1 - factFade).toFixed(3));
        this.style.setProperty('--nb-fact-y', (-14 * factFade).toFixed(2) + 'px');
        this.classList.toggle('is-copy-visible', copyOpacity > 0.72);
        this.style.setProperty('--nb-necklace-cx', centerX.toFixed(2) + 'px');
        this.style.setProperty('--nb-necklace-cy', centerY.toFixed(2) + 'px');
        this.style.setProperty('--nb-necklace-rx', radiusX.toFixed(2) + 'px');
        this.style.setProperty('--nb-necklace-ry', radiusY.toFixed(2) + 'px');
        this.style.setProperty('--nb-thread-opacity', Math.max(0, (formation - 0.68) / 0.32).toFixed(3));
        this.style.setProperty('--nb-thread-scale', (0.965 + formation * 0.035).toFixed(3));
        if (this.clasp) {
          this.style.setProperty('--nb-clasp-x', centerX.toFixed(2) + 'px');
          this.style.setProperty('--nb-clasp-y', (centerY - radiusY).toFixed(2) + 'px');
          this.clasp.style.setProperty('--clasp-opacity', Math.max(0, (formation - 0.74) / 0.26).toFixed(3));
          this.clasp.style.setProperty('--clasp-scale', (0.9 + formation * 0.1).toFixed(3));
        }

        visiblePearls.forEach((pearl, index) => {
          var ratio = count === 1 ? 0 : index / (count - 1);
          var isIntroPearl = index < introCount;
          var introRatio = introCount === 1 ? 0 : index / (introCount - 1);
          var angle = claspGapAngle + necklaceSpan * ratio;
          var targetX = centerX + Math.sin(angle) * radiusX;
          var targetY = centerY - Math.cos(angle) * radiusY;
          var rowCenterX = width / 2;
          var rowWidth = width * (mobile ? 0.82 : 0.6);
          var rowGap = count > 1 ? rowWidth / (count - 1) : rowWidth;
          var introGap = introCount > 1 ? rowWidth / (introCount - 1) : rowWidth;
          var rowRatio = isIntroPearl ? introRatio : ratio;
          var rowX = rowCenterX + (rowRatio - 0.5) * rowWidth;
          var rowY = isIntroPearl ? introRowY : height * (mobile ? 0.56 : 0.5);
          var mobileIntroDepth = 1;
          var mobileIntroOpacity = 1;
          var mobileIntroX = 0;
          var mobileIntroY = 0;
          if (mobile && isIntroPearl) {
            var scatterIndex = index % mobileIntroScatterX.length;
            var scatterWindow = Math.max(0.08, introMotionStart - timing.pearlRevealStart);
            var scatterSettle = this.easeOutCubic(this.clamp((progress - timing.pearlRevealStart) / scatterWindow));
            mobileIntroX = Math.sin(floatPhase + index * 1.17) * (1 - formation) * 2.5;
            mobileIntroY = Math.cos(floatPhase + index * 0.91) * (1 - formation) * 4;
            rowX = width * mobileIntroScatterX[scatterIndex] + mobileIntroX * scatterSettle;
            rowY = height * (mobileScatterTop + mobileIntroScatterY[scatterIndex] * mobileScatterHeight) + mobileIntroY * scatterSettle;
            mobileIntroDepth = mobileIntroScatterDepth[scatterIndex];
            mobileIntroOpacity = 0.88 + mobileIntroDepth * 0.12;
          }
          var introRevealOrder = mobile
            ? mobileIntroRevealOrder[index % mobileIntroRevealOrder.length] || 0
            : index;
          var introRevealDelay = isIntroPearl && introCount > 1
            ? timing.pearlRevealStart + (introRevealOrder / (introCount - 1)) * timing.introRevealSequenceSpread
            : timing.pearlRevealStart;
          var introPearlReveal = isIntroPearl
            ? this.easeOutCubic(this.clamp((progress - introRevealDelay) / timing.pearlRevealDuration))
            : 1;
          var lift = Math.sin(Math.PI * ratio) * height * (mobile ? 0.11 : 0.14);
          var controlX = rowX + (targetX - rowX) * 0.48;
          var controlY = isIntroPearl
            ? rowY + (targetY - rowY) * 0.24 - lift * 0.36
            : Math.min(rowY, targetY) - lift - height * 0.06;
          var introSequenceDelay = isIntroPearl ? (1 - introRatio) * introSequenceSpread : 0;
          var pulseDelay = isIntroPearl ? introMotionStart + introSequenceDelay : null;
          var localDelay = isIntroPearl ? pulseDelay + introPulseLead : introMotionStart + ratio * 0.16;
          var localEnd = isIntroPearl
            ? Math.min(1, Math.max(localDelay + 0.05, motionEnd - 0.02))
            : Math.max(localDelay + 0.05, motionEnd - 0.02);
          var localProgress = this.clamp((progress - localDelay) / (localEnd - localDelay));
          var localEase = this.easeInOutCubic(localProgress);
          var revealDelay = introMotionStart + 0.02 + ratio * 0.2;
          var backgroundReveal = isIntroPearl ? 1 : this.easeOutCubic(this.clamp((progress - revealDelay) / 0.36));
          var x = this.quadratic(rowX, controlX, targetX, localEase);
          var y = this.quadratic(rowY, controlY, targetY, localEase);
          var drift = Math.sin(floatPhase + index * 0.43) * (1 - formation) * (isIntroPearl ? 2 : 5);
          var backgroundDepth = isIntroPearl ? 0 : (1 - backgroundReveal) * (mobile ? 12 : 18);
          var depth = 0.92 + 0.11 * this.clamp((targetY - (centerY - radiusY)) / (radiusY * 2));
          var targetSize = (mobile ? mobileFinalPearlSize : 19) * depth;
          var introSize = mobile ? mobileIntroPearlSize * mobileIntroDepth : 65;
          var backgroundSize = Math.max(mobile ? 6 : 7, Math.min(mobile ? 9 : 10, rowGap * 0.28));
          var rowSize = isIntroPearl ? introSize : backgroundSize;
          var size = rowSize + (targetSize - rowSize) * localEase;
          var baseScale = isIntroPearl ? 0.92 + localEase * 0.08 : 0.78 + localEase * 0.22;
          var pulseProgress = isIntroPearl ? this.clamp((progress - pulseDelay) / pulseDuration) : 1;
          var pulse = isIntroPearl ? Math.sin(pulseProgress * Math.PI) * pulseStrength * (1 - localEase * 0.36) : 0;
          var revealGrowScale = isIntroPearl ? introRevealStartScale + (1 - introRevealStartScale) * introPearlReveal : 1;
          var scale = (baseScale + pulse) * revealGrowScale;
          var opacity = isIntroPearl
            ? introPearlReveal * (0.8 + localEase * 0.2) * mobileIntroOpacity
            : backgroundReveal * (0.14 + localEase * 0.86);

          pearl.style.setProperty('--x', x.toFixed(2) + 'px');
          pearl.style.setProperty('--y', (y + drift + backgroundDepth).toFixed(2) + 'px');
          pearl.style.setProperty('--size', size.toFixed(2) + 'px');
          pearl.style.setProperty('--scale', scale.toFixed(3));
          pearl.style.setProperty('--opacity', opacity.toFixed(3));

          if (isIntroPearl && this.labels && this.labels[index] && !this.labels[index].hidden) {
            var label = this.labels[index];
            var labelY = y + drift + backgroundDepth + size * 0.62 + (mobile ? 8 : 13);
            var labelFade = this.easeOutCubic(this.clamp(localEase / timing.labelFadeDuration));
            var labelOpacity = introPearlReveal * (1 - labelFade) * mobileIntroOpacity;
            label.style.setProperty('--label-x', x.toFixed(2) + 'px');
            label.style.setProperty('--label-y', labelY.toFixed(2) + 'px');
            label.style.setProperty('--label-scale', (mobile ? 0.86 + mobileIntroDepth * 0.08 : 1).toFixed(3));
            label.style.setProperty('--label-opacity', labelOpacity.toFixed(3));
          }
        });
      }

      getProgress() {
        var rect = this.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight || 800;
        var start = vh * 0.88;
        var end = vh * 0.18;
        return this.clamp((start - rect.top) / (start - end));
      }

      getTimingPercent(name, fallback) {
        var raw = Number(this.dataset[name]);
        if (!Number.isFinite(raw)) raw = fallback;
        return this.clamp(raw / 100);
      }

      getTimingDuration(name, fallback) {
        var raw = Number(this.dataset[name]);
        if (!Number.isFinite(raw)) raw = fallback;
        return Math.max(0.01, Math.min(1, raw / 100));
      }

      getNumberSetting(name, fallback, min, max) {
        var raw = Number(this.dataset[name]);
        if (!Number.isFinite(raw)) raw = fallback;
        return Math.max(min, Math.min(max, raw));
      }

      easeInOutCubic(value) {
        var t = this.clamp(value);
        return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      }

      easeOutCubic(value) {
        var t = this.clamp(value);
        return 1 - Math.pow(1 - t, 3);
      }

      quadratic(start, control, end, progress) {
        var inverse = 1 - progress;
        return inverse * inverse * start + 2 * inverse * progress * control + progress * progress * end;
      }

      clamp(value) {
        return Math.max(0, Math.min(1, value));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocean-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ocean-hero')) {
    customElements.define('ocean-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        this.video = this.querySelector('video');
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.visible = true;
        this.generation = 0;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.configure = () => {
          this.generation += 1;
          clearTimeout(this.watchdog);
          this.video.pause();
          this.removeAttribute('data-frame-ready');
          this.removeAttribute('data-playing');
          this.video.removeAttribute('src');
          this.video.load();
          this.source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
          this.failed = false;
          if (this.source && !this.reduced.matches && !this.connection?.saveData) this.start();
        };
        this.start = async () => {
          if (!this.source || !this.visible || document.hidden || this.failed) return;
          const generation = this.generation;
          if (!this.video.hasAttribute('src')) {
            this.video.src = this.source;
            this.video.load();
          }
          clearTimeout(this.watchdog);
          this.watchdog = setTimeout(() => {
            if (generation !== this.generation || this.video.paused) return;
            this.video.pause();
            this.removeAttribute('data-frame-ready');
          }, 10000);
          try { await this.video.play(); } catch (_) {
            if (generation === this.generation) {
              clearTimeout(this.watchdog);
              this.removeAttribute('data-playing');
            }
          }
        };
        const sync = () => {
          const playing = !this.video.paused;
          this.toggleAttribute('data-playing', playing);
        };
        this.video.addEventListener('playing', () => {
          clearTimeout(this.watchdog);
          const generation = this.generation;
          const reveal = () => {
            if (generation === this.generation && !this.video.paused) this.setAttribute('data-frame-ready', '');
          };
          if (this.video.requestVideoFrameCallback) this.video.requestVideoFrameCallback(reveal);
          else reveal();
          sync();
        }, options);
        this.video.addEventListener('pause', sync, options);
        this.video.addEventListener('error', () => {
          clearTimeout(this.watchdog);
          this.failed = true;
          this.video.pause();
          this.removeAttribute('data-frame-ready');
        }, options);
        const visibility = () => {
          if (document.hidden || !this.visible) this.video.pause();
          else if (!this.reduced.matches && !this.connection?.saveData) this.start();
        };
        document.addEventListener('visibilitychange', visibility, options);
        this.mobile.addEventListener('change', this.configure, options);
        this.reduced.addEventListener('change', this.configure, options);
        this.connection?.addEventListener('change', this.configure, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          visibility();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.cleanup = () => {
          clearTimeout(this.watchdog);
          this.controller.abort();
          this.observer.disconnect();
          this.video.pause();
        };
        this.configure();
      }
      disconnectedCallback() {
        this.cleanup?.();
        this.cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ocean-product-gallery"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ocean-product-gallery')) {
    customElements.define('ocean-product-gallery', class extends HTMLElement {
      connectedCallback() {
        if (this.carousel) return;
        this.events = new AbortController();
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.desktopLayout = window.matchMedia('(min-width: 768px)');
        this.track = this.querySelector('.ocean-gallery__track');
        if (!this.track) return;
        this.pieces = Array.from(this.track.children);
        this.dots = Array.from(this.querySelectorAll('[data-gallery-index]'));
        this.images = this.pieces.map(piece => piece.querySelector('.ocean-gallery__image'));
        this.initialize = () => {
          if (!this.isConnected || this.carousel || !window.Flickity) return;
          this.carousel = new Flickity(this.track, {
            cellSelector: '.ocean-gallery__piece',
            cellAlign: 'center',
            contain: false,
            wrapAround: this.pieces.length > 1,
            pageDots: false,
            prevNextButtons: false,
            autoPlay: false,
            rightToLeft: document.dir === 'rtl',
            selectedAttraction: .024,
            friction: .28,
            dragThreshold: 8,
            on: {
              scroll: () => this.paint(),
              change: () => this.updateSelection(),
              settle: () => this.announce()
            }
          });
          this.classList.add('is-ready');
          this.featureObserver = new IntersectionObserver(entries => {
            this.featureVisible = entries[0].isIntersecting;
            if (this.featureVisible) this.startFeatureVideo();
            else this.stopFeatureVideo();
          }, { threshold: .15 });
          this.featureObserver.observe(this.querySelector('[data-gallery-feature]'));
          navigator.connection?.addEventListener('change', () => this.startFeatureVideo(), { signal: this.events.signal });
          this.querySelector('.ocean-gallery__controls')?.removeAttribute('hidden');
          document.addEventListener('keydown', event => {
            if (['Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
              this.classList.add('is-keyboard-navigation');
            }
          }, { capture: true, signal: this.events.signal });
          this.addEventListener('pointerdown', () => {
            this.classList.remove('is-keyboard-navigation');
          }, { capture: true, signal: this.events.signal });
          this.addEventListener('click', event => {
            const piece = event.target.closest('.ocean-gallery__piece');
            if (piece && this.track.contains(piece) && !event.defaultPrevented) {
              const index = this.pieces.indexOf(piece);
              if (index !== this.carousel.selectedIndex) {
                event.preventDefault();
                this.select(index);
              }
            }
            const dot = event.target.closest('[data-gallery-index]');
            if (dot) this.select(Number(dot.dataset.galleryIndex));
          }, { signal: this.events.signal });
          this.track.addEventListener('keydown', event => {
            if (!['Home', 'End', 'ArrowLeft', 'ArrowRight'].includes(event.key)) return;
            event.preventDefault();
            event.stopImmediatePropagation();
            if (event.key === 'Home') this.select(0);
            else if (event.key === 'End') this.select(this.pieces.length - 1);
            else {
              const direction = event.key === 'ArrowRight' ? 1 : -1;
              this.select(this.carousel.selectedIndex + direction * (document.dir === 'rtl' ? -1 : 1));
            }
          }, { capture: true, signal: this.events.signal });
          this.resizeObserver = new ResizeObserver(entries => {
            const width = entries[0].contentRect.width;
            if (width === this.lastWidth) return;
            this.lastWidth = width;
            cancelAnimationFrame(this.resizeFrame);
            this.resizeFrame = requestAnimationFrame(() => this.refreshLayout());
          });
          this.resizeObserver.observe(this);
          this.updateSelection();
          this.refreshLayout();
          document.fonts.ready.then(() => this.refreshLayout());
        };
        if (window.Flickity) this.initialize();
        else window.addEventListener('load', this.initialize, { once: true, signal: this.events.signal });
      }
      select(index) {
        this.carousel.select(index, true, this.reducedMotion.matches);
      }
      refreshLayout() {
        if (!this.carousel) return;
        this.style.removeProperty('--gallery-title-height');
        const height = Math.max(...this.pieces.map(piece => piece.querySelector('h3').offsetHeight));
        this.style.setProperty('--gallery-title-height', `${height}px`);
        this.carousel.resize();
        this.preloadNearbyImages();
        this.paint();
      }
      paint() {
        const carousel = this.carousel;
        if (!carousel) return;
        const length = carousel.slideableWidth;
        carousel.cells.forEach((cell, index) => {
          let distance = cell.target + carousel.x;
          if (carousel.options.wrapAround && length) {
            distance = ((distance + length / 2) % length + length) % length - length / 2;
          }
          const depth = Math.abs(distance) / cell.size.outerWidth;
          const progress = Math.min(depth, 1);
          const scale = this.reducedMotion.matches ? (index === carousel.selectedIndex ? 1 : .62) : 1 - progress * .38;
          const opacity = this.desktopLayout.matches
            ? (depth <= 1 ? 1 - depth * .5 : Math.max(.25, .5 - (depth - 1) * .25))
            : 1 - progress * .5;
          const y = this.desktopLayout.matches && !this.reducedMotion.matches ? -28 * Math.pow(Math.min(depth, 2), 1.2) : 0;
          this.images[index]?.style.setProperty('--piece-scale', scale.toFixed(4));
          this.images[index]?.style.setProperty('--piece-opacity', opacity.toFixed(4));
          this.images[index]?.style.setProperty('--piece-y', `${y.toFixed(2)}px`);
        });
      }
      updateSelection() {
        const index = this.carousel.selectedIndex;
        const feature = this.querySelector('[data-gallery-feature]');
        if (feature) {
          this.stopFeatureVideo();
          const clone = this.carousel.selectedElement.cloneNode(true);
          clone.removeAttribute('style');
          clone.classList.add('is-selected');
          clone.removeAttribute('aria-hidden');
          const link = clone.querySelector('a');
          if (link) link.tabIndex = 0;
          const image = clone.querySelector('img');
          if (image) {
            image.removeAttribute('srcset');
            image.src = clone.dataset.featureImage;
            image.loading = 'lazy';
          }
          const details = clone.querySelector('.ocean-gallery__details');
          const caption = this.querySelector('[data-gallery-caption]');
          if (details && caption) {
            const captionLink = document.createElement('a');
            captionLink.href = link.href;
            captionLink.setAttribute('aria-label', link.getAttribute('aria-label'));
            captionLink.append(details);
            caption.replaceChildren(captionLink);
          }
          feature.replaceChildren(clone);
          this.startFeatureVideo();
        }
        const counter = this.querySelector('[data-gallery-counter]');
        if (counter) counter.textContent = `${String(index + 1).padStart(2, '0')} / ${String(this.pieces.length).padStart(2, '0')}`;
        const focusWasInPiece = this.pieces.some(piece => piece.contains(document.activeElement));
        this.pieces.forEach((piece, i) => {
          piece.querySelector('a').tabIndex = i === index ? 0 : -1;
        });
        if (focusWasInPiece) this.track.focus({ preventScroll: true });
        const firstDot = Math.max(0, Math.min(index - 2, this.dots.length - 5));
        this.dots.forEach((dot, i) => {
          dot.hidden = i < firstDot || i >= firstDot + 5;
          if (i === index) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        this.preloadNearbyImages();
        this.paint();
      }
      preloadNearbyImages() {
        const index = this.carousel.selectedIndex;
        const offsets = this.desktopLayout.matches ? [-2, -1, 0, 1, 2] : [-1, 0, 1];
        offsets.forEach(offset => {
          const i = index + offset;
          const image = this.images[(i + this.images.length) % this.images.length];
          if (image?.tagName === 'IMG') image.loading = 'eager';
        });
      }
      startFeatureVideo() {
        const feature = this.querySelector('[data-gallery-feature]');
        const item = feature?.querySelector('.ocean-gallery__piece');
        const connection = navigator.connection;
        if (!this.featureVisible || this.reducedMotion.matches || !item?.dataset.featureVideo || !connection || connection.saveData || connection.effectiveType !== '4g' || (connection.downlink && connection.downlink < 3)) {
          this.stopFeatureVideo();
          return;
        }
        if (feature.querySelector('video')) return;
        const video = document.createElement('video');
        video.className = 'ocean-gallery__video';
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.setAttribute('aria-hidden', 'true');
        video.src = item.dataset.featureVideo;
        video.addEventListener('playing', () => video.classList.add('is-playing'));
        video.addEventListener('error', () => video.remove());
        item.querySelector('.ocean-gallery__media').append(video);
        video.play().catch(() => video.remove());
      }
      stopFeatureVideo() {
        const video = this.querySelector('[data-gallery-feature] video');
        if (video) {
          video.pause();
          video.removeAttribute('src');
          video.load();
          video.remove();
        }
      }
      announce() {
        const status = this.querySelector('.ocean-gallery__status');
        const title = this.carousel.selectedElement.querySelector('.ocean-gallery__original-title').textContent;
        status.textContent = `${this.carousel.selectedIndex + 1} / ${this.pieces.length}: ${title}`;
      }
      disconnectedCallback() {
        this.stopFeatureVideo();
        this.featureObserver?.disconnect();
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.resizeFrame);
        this.carousel?.destroy();
        this.carousel = null;
        this.lastWidth = null;
        this.classList.remove('is-ready', 'is-keyboard-navigation');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["our-story-home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('our-story-ocean-hero')) {
    customElements.define('our-story-ocean-hero', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        this.video = this.querySelector('video');
        this.mobile = matchMedia('(max-width: 767px)');
        this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
        this.connection = navigator.connection;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.visible = true;
        this.generation = 0;
        this.playback = this.querySelector('[data-story-playback]');
        this.userPaused = false;
        this.video.muted = true;
        this.video.defaultMuted = true;
        this.configure = () => {
          this.generation += 1;
          clearTimeout(this.watchdog);
          this.video.pause();
          this.removeAttribute('data-frame-ready');
          this.removeAttribute('data-playing');
          this.video.removeAttribute('src');
          this.video.load();
          this.source = this.mobile.matches ? this.dataset.mobileSrc : this.dataset.desktopSrc;
          this.failed = false;
          if (this.source && !this.reduced.matches && !this.connection?.saveData) this.start();
        };
        this.start = async () => {
          if (!this.source || !this.visible || document.hidden || this.failed || this.userPaused) return;
          const generation = this.generation;
          if (!this.video.hasAttribute('src')) {
            this.video.src = this.source;
            this.video.load();
          }
          clearTimeout(this.watchdog);
          this.watchdog = setTimeout(() => {
            if (generation !== this.generation || this.video.paused) return;
            this.video.pause();
            this.removeAttribute('data-frame-ready');
          }, 10000);
          try { await this.video.play(); } catch (_) {
            if (generation === this.generation) {
              clearTimeout(this.watchdog);
              this.removeAttribute('data-playing');
            }
          }
        };
        const sync = () => {
          const playing = !this.video.paused;
          this.toggleAttribute('data-playing', playing);
          this.playback.textContent = playing ? this.playback.dataset.pause : this.playback.dataset.play;
        };
        this.playback.addEventListener('click', () => { if(this.video.paused) { this.userPaused = false; this.start(); } else { this.userPaused = true; this.video.pause(); } }, options);
        this.video.addEventListener('playing', () => {
          clearTimeout(this.watchdog);
          const generation = this.generation;
          const reveal = () => {
            if (generation === this.generation && !this.video.paused) this.setAttribute('data-frame-ready', '');
          };
          if (this.video.requestVideoFrameCallback) this.video.requestVideoFrameCallback(reveal);
          else reveal();
          sync();
        }, options);
        this.video.addEventListener('pause', sync, options);
        this.video.addEventListener('error', () => {
          clearTimeout(this.watchdog);
          this.failed = true;
          this.video.pause();
          this.removeAttribute('data-frame-ready');
        }, options);
        const visibility = () => {
          if (document.hidden || !this.visible) this.video.pause();
          else if (!this.reduced.matches && !this.connection?.saveData) this.start();
        };
        document.addEventListener('visibilitychange', visibility, options);
        this.mobile.addEventListener('change', this.configure, options);
        this.reduced.addEventListener('change', this.configure, options);
        this.connection?.addEventListener('change', this.configure, options);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting;
          visibility();
        }, { threshold: 0.05 });
        this.observer.observe(this);
        this.cleanup = () => {
          clearTimeout(this.watchdog);
          this.controller.abort();
          this.observer.disconnect();
          this.video.pause();
        };
        this.configure();
      }
      disconnectedCallback() {
        this.cleanup?.();
        this.cleanup = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-farm-story-seo"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pearl-farm-story')) {
  customElements.define('pearl-farm-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const header = document.querySelector('#header');
      const nav = this.querySelector('.pf-nav');
      const hero = this.querySelector('.pf-hero');
      const heroImage = this.querySelector('[data-pf-parallax]');
      const steps = [...this.querySelectorAll('[data-pf-step]')];
      const frames = [...this.querySelectorAll('[data-pf-frame]')];
      const chapters = [...this.querySelectorAll('[data-pf-chapter]')];
      const sections = [...this.querySelectorAll('[data-pf-section]')];

      const players = [...this.querySelectorAll('[data-pf-player]')];
      const videoStates = new Map();
      const setButton = (player, video) => {
        const button = player.querySelector('[data-pf-toggle]');
        if (!button) return;
        const label = video.paused ? button.dataset.pfPlayLabel : button.dataset.pfPauseLabel;
        button.textContent = label;
        button.setAttribute('aria-label', label);
      };
      const syncVideos = () => {
        for (const [video, state] of videoStates) {
          const rect = state.player.getBoundingClientRect();
          const frame = state.player.closest('[data-pf-frame]');
          const eligible = !document.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && (!frame || frame.classList.contains('is-active'));
          if (!eligible) {
            if (!video.paused) { state.intent = 'pause'; video.pause(); }
            state.blocked = false;
          } else if (state.auto && !reduce.matches && !state.userPaused && !state.blocked && video.paused && !state.pending) {
            state.intent = 'play';
            state.pending = true;
            video.muted = true;
            video.play().catch(() => { state.blocked = true; }).finally(() => { state.pending = false; });
          }
          setButton(state.player, video);
        }
      };
      for (const player of players) {
        const video = player.querySelector('video');
        if (!video) continue;
        const state = {player, auto:player.dataset.pfAutoplay === 'true', userPaused:false, blocked:false, pending:false, intent:'pause'};
        videoStates.set(video, state);
        video.addEventListener('play', () => { state.userPaused = false; state.intent = 'play'; setButton(player, video); }, {signal});
        video.addEventListener('pause', () => { if (state.intent !== 'pause') state.userPaused = true; setButton(player, video); }, {signal});
        video.addEventListener('error', () => { player.classList.add('is-error'); }, {signal});
        player.querySelector('[data-pf-toggle]')?.addEventListener('click', () => {
          if (video.paused) {
            state.userPaused = false; state.blocked = false; state.intent = 'play'; video.muted = true;
            video.play().catch(() => { state.blocked = true; });
          } else { state.userPaused = true; state.intent = 'pause'; video.pause(); }
        }, {signal});
      }
      this.pauseVideos = () => { for (const [video, state] of videoStates) { state.intent = 'pause'; video.pause(); } };

      let pending = false;
      let active = '';
      const update = () => {
        pending = false;
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        this.style.setProperty('--pf-header', `${headerBottom}px`);
        const threshold = headerBottom + nav.offsetHeight + innerHeight * .32;
        if (innerWidth >= 900) {
          let current = steps[0];
          for (const step of steps) {
            if (step.getBoundingClientRect().top <= threshold) current = step;
          }
          if (current && current.dataset.pfStep !== active) {
            active = current.dataset.pfStep;
            frames.forEach(frame => {
              const selected = frame.dataset.pfFrame === active;
              frame.classList.toggle('is-active', selected);
              frame.inert = !selected;
              frame.setAttribute('aria-hidden', String(!selected));
            });
            this.querySelector('[data-pf-current]').textContent = current.dataset.pfName;
          }
        }
        let chapter = null;
        for (const section of sections) {
          if (section.getBoundingClientRect().top <= headerBottom + nav.offsetHeight + 100) chapter = section.id;
        }
        chapters.forEach(link => {
          if (link.hash === `#${chapter}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        syncVideos();
        const bounds = hero.getBoundingClientRect();
        if (!reduce.matches && bounds.bottom > 0 && bounds.top < innerHeight) {
          heroImage.style.transform = `translateY(${Math.max(0, -bounds.top) * .17}px)`;
        }
      };
      const schedule = () => { if (!pending) { pending = true; this.frame = requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, {passive:true, signal});
      addEventListener('resize', schedule, {passive:true, signal});
      document.addEventListener('visibilitychange', schedule, {signal});
      reduce.addEventListener('change', () => { if (reduce.matches) { heroImage.style.transform = ''; this.pauseVideos(); } schedule(); }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        const top = target.getBoundingClientRect().top + scrollY - headerBottom - nav.offsetHeight - 24;
        window.scrollTo({top:Math.max(0, top), behavior:reduce.matches ? 'instant' : 'smooth'});
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.reveals.unobserve(entry.target); }
        }), {rootMargin:'0px 0px -25px 0px', threshold:.05});
        this.querySelectorAll('[data-pf-reveal]').forEach(el => this.reveals.observe(el));
        this.classList.add('pf-ready');
      }
      this.videoObserver = new IntersectionObserver(schedule, {threshold:[0, .1, .5]});
      players.forEach(player => this.videoObserver.observe(player));
      this.sizes = new ResizeObserver(schedule);
      if (header) this.sizes.observe(header);
      this.sizes.observe(nav);
      update();
    }
    disconnectedCallback() {
      this.pauseVideos?.();
      this.videoObserver?.disconnect();
      this.abort?.abort();
      this.reveals?.disconnect();
      this.sizes?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-farm-story-video"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pearl-farm-story')) {
  customElements.define('pearl-farm-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const header = document.querySelector('#header');
      const nav = this.querySelector('.pf-nav');
      const hero = this.querySelector('.pf-hero');
      const heroImage = this.querySelector('[data-pf-parallax]');
      const steps = [...this.querySelectorAll('[data-pf-step]')];
      const frames = [...this.querySelectorAll('[data-pf-frame]')];
      const chapters = [...this.querySelectorAll('[data-pf-chapter]')];
      const sections = [...this.querySelectorAll('[data-pf-section]')];

      const players = [...this.querySelectorAll('[data-pf-player]')];
      const videoStates = new Map();
      const setButton = (player, video) => {
        const button = player.querySelector('[data-pf-toggle]');
        if (!button) return;
        const label = video.paused ? button.dataset.pfPlayLabel : button.dataset.pfPauseLabel;
        button.textContent = label;
        button.setAttribute('aria-label', label);
      };
      const syncVideos = () => {
        for (const [video, state] of videoStates) {
          const rect = state.player.getBoundingClientRect();
          const frame = state.player.closest('[data-pf-frame]');
          const eligible = !document.hidden && rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight && (!frame || frame.classList.contains('is-active'));
          if (!eligible) {
            if (!video.paused) { state.intent = 'pause'; video.pause(); }
            state.blocked = false;
          } else if (state.auto && !reduce.matches && !state.userPaused && !state.blocked && video.paused && !state.pending) {
            state.intent = 'play';
            state.pending = true;
            video.muted = true;
            video.play().catch(() => { state.blocked = true; }).finally(() => { state.pending = false; });
          }
          setButton(state.player, video);
        }
      };
      for (const player of players) {
        const video = player.querySelector('video');
        if (!video) continue;
        const state = {player, auto:player.dataset.pfAutoplay === 'true', userPaused:false, blocked:false, pending:false, intent:'pause'};
        videoStates.set(video, state);
        video.addEventListener('play', () => { state.userPaused = false; state.intent = 'play'; setButton(player, video); }, {signal});
        video.addEventListener('pause', () => { if (state.intent !== 'pause') state.userPaused = true; setButton(player, video); }, {signal});
        video.addEventListener('error', () => { player.classList.add('is-error'); }, {signal});
        player.querySelector('[data-pf-toggle]')?.addEventListener('click', () => {
          if (video.paused) {
            state.userPaused = false; state.blocked = false; state.intent = 'play'; video.muted = true;
            video.play().catch(() => { state.blocked = true; });
          } else { state.userPaused = true; state.intent = 'pause'; video.pause(); }
        }, {signal});
      }
      this.pauseVideos = () => { for (const [video, state] of videoStates) { state.intent = 'pause'; video.pause(); } };

      let pending = false;
      let active = '';
      const update = () => {
        pending = false;
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        this.style.setProperty('--pf-header', `${headerBottom}px`);
        const threshold = headerBottom + nav.offsetHeight + innerHeight * .32;
        if (innerWidth >= 900) {
          let current = steps[0];
          for (const step of steps) {
            if (step.getBoundingClientRect().top <= threshold) current = step;
          }
          if (current && current.dataset.pfStep !== active) {
            active = current.dataset.pfStep;
            frames.forEach(frame => {
              const selected = frame.dataset.pfFrame === active;
              frame.classList.toggle('is-active', selected);
              frame.inert = !selected;
              frame.setAttribute('aria-hidden', String(!selected));
            });
            this.querySelector('[data-pf-current]').textContent = current.dataset.pfName;
          }
        }
        let chapter = null;
        for (const section of sections) {
          if (section.getBoundingClientRect().top <= headerBottom + nav.offsetHeight + 100) chapter = section.id;
        }
        chapters.forEach(link => {
          if (link.hash === `#${chapter}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        syncVideos();
        const bounds = hero.getBoundingClientRect();
        if (!reduce.matches && bounds.bottom > 0 && bounds.top < innerHeight) {
          heroImage.style.transform = `translateY(${Math.max(0, -bounds.top) * .17}px)`;
        }
      };
      const schedule = () => { if (!pending) { pending = true; this.frame = requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, {passive:true, signal});
      addEventListener('resize', schedule, {passive:true, signal});
      document.addEventListener('visibilitychange', schedule, {signal});
      reduce.addEventListener('change', () => { if (reduce.matches) { heroImage.style.transform = ''; this.pauseVideos(); } schedule(); }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        const top = target.getBoundingClientRect().top + scrollY - headerBottom - nav.offsetHeight - 24;
        window.scrollTo({top:Math.max(0, top), behavior:reduce.matches ? 'instant' : 'smooth'});
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.reveals.unobserve(entry.target); }
        }), {rootMargin:'0px 0px -25px 0px', threshold:.05});
        this.querySelectorAll('[data-pf-reveal]').forEach(el => this.reveals.observe(el));
        this.classList.add('pf-ready');
      }
      this.videoObserver = new IntersectionObserver(schedule, {threshold:[0, .1, .5]});
      players.forEach(player => this.videoObserver.observe(player));
      this.sizes = new ResizeObserver(schedule);
      if (header) this.sizes.observe(header);
      this.sizes.observe(nav);
      update();
    }
    disconnectedCallback() {
      this.pauseVideos?.();
      this.videoObserver?.disconnect();
      this.abort?.abort();
      this.reveals?.disconnect();
      this.sizes?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pearl-farm-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('pearl-farm-story')) {
  customElements.define('pearl-farm-story', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const reduce = matchMedia('(prefers-reduced-motion: reduce)');
      const header = document.querySelector('#header');
      const nav = this.querySelector('.pf-nav');
      const hero = this.querySelector('.pf-hero');
      const heroImage = this.querySelector('[data-pf-parallax]');
      const steps = [...this.querySelectorAll('[data-pf-step]')];
      const frames = [...this.querySelectorAll('[data-pf-frame]')];
      const chapters = [...this.querySelectorAll('[data-pf-chapter]')];
      const sections = [...this.querySelectorAll('[data-pf-section]')];
      let pending = false;
      let active = '';
      const update = () => {
        pending = false;
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        this.style.setProperty('--pf-header', `${headerBottom}px`);
        const threshold = headerBottom + nav.offsetHeight + innerHeight * .32;
        if (innerWidth >= 900) {
          let current = steps[0];
          for (const step of steps) {
            if (step.getBoundingClientRect().top <= threshold) current = step;
          }
          if (current && current.dataset.pfStep !== active) {
            active = current.dataset.pfStep;
            frames.forEach(frame => frame.classList.toggle('is-active', frame.dataset.pfFrame === active));
            this.querySelector('[data-pf-current]').textContent = current.dataset.pfName;
          }
        }
        let chapter = null;
        for (const section of sections) {
          if (section.getBoundingClientRect().top <= headerBottom + nav.offsetHeight + 100) chapter = section.id;
        }
        chapters.forEach(link => {
          if (link.hash === `#${chapter}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        const bounds = hero.getBoundingClientRect();
        if (!reduce.matches && bounds.bottom > 0 && bounds.top < innerHeight) {
          heroImage.style.transform = `translateY(${Math.max(0, -bounds.top) * .17}px)`;
        }
      };
      const schedule = () => { if (!pending) { pending = true; this.frame = requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, {passive:true, signal});
      addEventListener('resize', schedule, {passive:true, signal});
      reduce.addEventListener('change', () => { if (reduce.matches) heroImage.style.transform = ''; schedule(); }, {signal});
      this.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        if (!target || !this.contains(target)) return;
        event.preventDefault();
        event.stopPropagation();
        const headerBottom = header ? Math.max(0, Math.min(header.getBoundingClientRect().bottom, header.offsetHeight)) : 0;
        const top = target.getBoundingClientRect().top + scrollY - headerBottom - nav.offsetHeight - 24;
        window.scrollTo({top:Math.max(0, top), behavior:reduce.matches ? 'instant' : 'smooth'});
        history.replaceState(null, '', link.hash);
        target.setAttribute('tabindex','-1');
        target.focus({preventScroll:true});
      }, {signal});
      if ('IntersectionObserver' in window) {
        this.reveals = new IntersectionObserver(entries => entries.forEach(entry => {
          if (entry.isIntersecting) { entry.target.classList.add('is-visible'); this.reveals.unobserve(entry.target); }
        }), {rootMargin:'0px 0px -25px 0px', threshold:.05});
        this.querySelectorAll('[data-pf-reveal]').forEach(el => this.reveals.observe(el));
        this.classList.add('pf-ready');
      }
      this.sizes = new ResizeObserver(schedule);
      if (header) this.sizes.observe(header);
      this.sizes.observe(nav);
      update();
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.reveals?.disconnect();
      this.sizes?.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-story-modules"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-story-modules')) {
    class ProductStoryModules extends HTMLElement {
      connectedCallback() {
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.header = document.querySelector('.header-section');
        this.update = this.update.bind(this);
        this.onScroll = () => {
          if (!this.frame) this.frame = requestAnimationFrame(this.update);
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll);
        this.mobile.addEventListener('change', this.onScroll);
        if (this.header) {
          this.resizeObserver = new ResizeObserver(this.onScroll);
          this.resizeObserver.observe(this.header);
        }
        this.revealObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            this.revealObserver.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        this.querySelectorAll('.fullscreen-corner-media__text, .image-with-text-ultra__content-inner').forEach((content) => {
          content.classList.add('story-reveal-ready');
          this.revealObserver.observe(content);
        });
        this.update();
      }

      update() {
        this.frame = 0;
        const headerHeight = this.header ? this.header.getBoundingClientRect().height : 0;
        this.style.setProperty('--story-header-height', `${headerHeight}px`);
        const rect = this.getBoundingClientRect();
        const readingLine = headerHeight + (window.innerHeight - headerHeight) * 0.45;
        this.toggleAttribute('data-reading', this.mobile.matches && rect.top < readingLine && rect.bottom > readingLine);
        document.documentElement.classList.toggle('story-immersive', !!document.querySelector('product-story-modules[data-reading]'));
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.onScroll);
        window.removeEventListener('resize', this.onScroll);
        this.mobile?.removeEventListener('change', this.onScroll);
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
        cancelAnimationFrame(this.frame);
        document.documentElement.classList.toggle('story-immersive', !!document.querySelector('product-story-modules[data-reading]'));
      }
    }
    customElements.define('product-story-modules', ProductStoryModules);
  }

  } catch(e) { console.error(e); }
})();
})();
